module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vwassets/new2/_next/static/images/pdp_paperNatural-b3fdf2fdd24755e5e373305d394d9ee4.jpg";